import { useId, useState } from 'react';

/** Password input with a show/hide toggle, wired up for screen readers. */
export default function PasswordField({ label, hint, error, value, onChange, autoComplete = 'current-password', ...props }) {
  const id = useId();
  const [shown, setShown] = useState(false);
  const hintId = hint ? `${id}-hint` : undefined;
  const errId = error ? `${id}-err` : undefined;
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="password-wrap">
        <input id={id} type={shown ? 'text' : 'password'} value={value} onChange={onChange} autoComplete={autoComplete}
          aria-describedby={[hintId, errId].filter(Boolean).join(' ') || undefined}
          aria-invalid={error ? 'true' : undefined} {...props} />
        <button type="button" className="password-toggle" onClick={() => setShown(!shown)}
          aria-label={shown ? 'Hide password' : 'Show password'} aria-pressed={shown}>
          {shown ? 'Hide' : 'Show'}
        </button>
      </div>
      {hint && <p id={hintId} className="field-hint">{hint}</p>}
      {error && <p id={errId} className="field-error">{error}</p>}
    </div>
  );
}
